import React, { useState } from 'react';
import Button from '@atlaskit/button';
import DropdownMenu, {
	type CustomTriggerProps,
	DropdownItem,
	DropdownItemGroup,
} from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { useIntl } from '@atlassian/jira-intl';
import ProjectUnarchiveModal from '@atlassian/jira-project-unarchive-modal/src/async';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import messages from './messages';
import type { Props } from './types';

const UnarchiveAction = (props: Props) => {
	const { project, refetchProjects } = props;
	const {
		name: projectName,
		id: projectId,
		typeKey: projectType,
		key: projectKey,
		simplified: isProjectSimplified,
		permissions,
	} = project;
	const [isProjectUnarchiveModalOpen, setProjectUnarchiveModalOpen] = useState<boolean>(false);
	const isAdmin = useIsAdmin();
	const baseUrl = '';

	const { formatMessage } = useIntl();

	const openProjectUnarchiveModal = (): void => {
		setProjectUnarchiveModalOpen(true);
	};
	const closeProjectUnarchiveModal = (): void => {
		setProjectUnarchiveModalOpen(false);
	};
	const hasEditPermission = () => (permissions && permissions.canEdit) || isAdmin;

	if (!hasEditPermission()) {
		return null;
	}

	return (
		<div data-test-id="inactive-projects-directory-base.ui.projects-table.body.cells.unarchive">
			<DropdownMenu
				placement="bottom-end"
				testId="inactive-projects-directory-base.ui.projects-table.body.cells.unarchive.dropdown"
				trigger={({ triggerRef, ...restProps }: CustomTriggerProps) => (
					<Button
						{...restProps}
						iconBefore={<MoreIcon label={formatMessage(messages.menuLabel)} />}
						ref={triggerRef}
						appearance="subtle"
					/>
				)}
			>
				<DropdownItemGroup>
					<DropdownItem onClick={openProjectUnarchiveModal}>
						{formatMessage(messages.actionUnarchiveProject)}
					</DropdownItem>
				</DropdownItemGroup>
			</DropdownMenu>
			{isProjectUnarchiveModalOpen && (
				<ProjectUnarchiveModal
					onClose={closeProjectUnarchiveModal}
					projectId={projectId}
					projectType={projectType}
					projectName={projectName}
					projectKey={projectKey}
					baseUrl={baseUrl}
					onUnarchiveSuccess={refetchProjects}
					isProjectSimplified={isProjectSimplified}
				/>
			)}
		</div>
	);
};

export default UnarchiveAction;
